<template>
  <div class="login-form-box login-form-box-email">
    <div class="title">
      <LoginEmailTitle />
    </div>

    <PaFrontForm
      class="pa-login-box-form"
      :action="'/'"
      :formSet="formSet"
      :submitText="'接続'"
      :submitLoading="submitLoading"
      
      @handleSubmit="submitLoginWithEmail"
    />

    <div class="republish-password">
      <router-link :to="{name:'forgot'}">パスワード再発行</router-link>
    </div>

    <transition name="login-ticket-valid">
      <div class="pa-login-ticket-valid" v-if="isLoginTicketValid">
        <LoginTicketValid />
      </div>
    </transition>

    <transition name="login-ticket-valid-cut" v-on:after-enter="afterTicketValidAnimation">
      <div class="pa-login-ticket-valid-cut" v-if="isLoginTicketValidCut">
        <LoginTicketCut />
      </div>
    </transition>
  </div>
</template>

<script>
import LoginEmailTitle  from '@/components/FrontParts/LoginModal/LoginBox/Images/login_mail_title.svg?inlineF'
import LoginTicketValid from '@/components/FrontParts/LoginModal/LoginBox/Images/login_ticket_valid.svg?inlineF'
import LoginTicketCut   from '@/components/FrontParts/LoginModal/LoginBox/Images/login_tiket_cut.svg?inlineF'

import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

export default {
  name        : 'LoginWithEmailBox',
  mixins      : [
    FormValidationControlMixin
  ],
  components : {
    LoginEmailTitle,
    LoginTicketValid,
    LoginTicketCut,
    PaFrontForm
  },
  data(){
    return {
      formSet                     : {
        email                 : {
          label           : 'メールアドレス',
          description     : null,
          validationRules : ['notEmpty', 'email', 'max'],
          inputType       : 'email',
        },

        password              : {
          label           : 'パスワード',
          description     : null,
          validationRules : ['notEmpty', 'max'],
          // 'password'のバリデーションは実行しません。（旧システムで登録したユーザーがログインできなくなるため）
          inputType       : 'password',
        },
      },

      submitLoading       : false,
      
      connectButtonClass  : {
        'is-loading'  : false,
      },

      isLoginTicketValid    : false,

      isLoginTicketValidCut : false
    };
  },
  methods : {
    afterTicketValidAnimation(){
      this.$parent.$parent.$parent.$parent.$emit('changeLoginContentBox', 'loading');
    },

    loginError(){
      this.unDisabledFields();
      this.submitLoading = false;

      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;メールアドレスとパスワードの入力が正しくありません。',
        status      : 'error',
        hasControl  : true,
        autoClose   : 8000
      }, {root:true});
    },
    
    async submitLoginWithEmail(){
      this.submitLoading = true;
      this.disabledFields();

      if( this.checkFormPreValidation() ){
        const results = await this.$store.dispatch({
          type      : 'requests/auth/login',
          email     : this.formSet['email']['value'],
          password  : this.formSet['password']['value'],
        });
        
        await this.RESTResultResultValidationGuard(results, [422, 401]);

        switch(results.status){
          case 200:
            this.isLoginTicketValid = true;
            this.isLoginTicketValidCut = true;
            this.submitLoading = false;
          break;

          case 422:
          case 401:
            this.loginError();
          break;
        }
      }else{
        this.loginError();
      }
    }
  },
  created : function(){
    this.initializeValid();
  },
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

@keyframes simpleFadeIn
{
  0%   {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes ticketPunching {
  0% {transform: scale(1) translate(0, 0); opacity:1;}
  100% {transform: scale(.8) translate(0, 40px); opacity:.7;}
}

.login-ticket-valid{
  &-enter-active{
      animation-name: simpleFadeIn;
      animation-duration: .2s;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.login-ticket-valid-cut{
  &-enter-active{
      animation-name: ticketPunching;
      animation-duration: 1.6s;
      animation-iteration-count: 1;
  }

  &-enter, &-leave-to{
    opacity: 0;
  }
}

.login-form-box{
  margin: 0 8px;
  background-color: #7A4E26;
  border:8px solid #603411;
  border-radius: 12px;
  font-size:.8rem;
  line-height: 1.3rem;
  text-align: center;

  div.title{
    margin-bottom:0;

    img, svg{
      width:9rem;
      margin:0 auto;
      padding:8px 0 6px;
    }
  }

  form.pa-front-form{
    &.pa-login-box-form{
      position: relative;

      .form-set{
        width:95%;
        margin:0 auto .5rem;
        border:4px solid #89620C;
        background-color: #DDCEB3;
        border-radius: 6px;
        font-size: .72rem;
        display: flex;
        flex-direction: row;

        .title{
          width:35%;
          display: block;
          text-align: right;
          padding:.2rem 0;
          border:0;
          font-size: .72rem;

          &::after{
            content:'：';
          }

          .valid-error{
            display:none;
          }
        }

        .description{
          display: none;
        }

        .input-area{
          width:65%;
          display: block;
          border:0;
          margin:0;
          padding:0;
          height: auto;
          text-decoration: none;
          border-radius: 0;
          line-height: normal;
          background-color: inherit;
          border:0;

          input{
            border:0;
            margin:0;
            padding:.2rem 0;
            height: auto;
            border-radius:0;
            font-size: .72rem;
            background-color: inherit;
          }
        }

        &:last-child{
          width:100%;
          margin:0 auto;
          border:0;
          background-color: inherit;
          border-radius:0;
          font-size:auto;
          display: block;

          button{
            border:2px solid #723E14;
            background-color:#874D26;
            border-radius: 6px;
            font-size: 1rem;
            padding:2px 1.8rem;
            color:#E8C5AC;
            font-weight: bold;
            line-height: 1.4rem;
            height: auto;
          }
        }
      }
    }
  }

  div.republish-password{
    position: absolute;
    bottom:1.8rem;
    left:1.5rem;

    a{
      color:#BB995C;
      text-decoration: underline;
      font-size: .65rem;
    }
  }

  div.pa-login-ticket-valid{
    z-index: 806;
    position: absolute;
    right:2rem;
    bottom:-8px;

    img, svg{
      width:35px;
    }

    &-cut{
      z-index: 807;
      position: absolute;
      opacity:0;
      right:2rem;
      bottom:-8px;

      img, svg{
        width:35px;
      }
    }
  }

  &-email{
    background-repeat: no-repeat;
    background-position: center;
    background-size:112%;
    background-image: url("Images/back_image_email.svg");
  }
}
</style>
